










































import { mixins } from 'vue-class-component';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import gql from 'graphql-tag';
import { BoxStyle, BoxStyleDimension } from '../../../common/box';
import _ from 'lodash';
import { apolloClient } from '../apollo';

import * as BOX_DIMENSIONS_FRAGMENT_QUERY from 'src/graphql/BoxDimensionsFragment.graphql'

@Component
export default class BoxDimensionSelect extends Vue {
  @Prop() editable : boolean;

  localBoxDimensionValues = [];
  localBoxDimensionTextValues = [];
  updateDimensionsDebounced = _.debounce(this.updateDimensionValues, 500);

  dimensionUpperLimit(index : number) {
    return this.box.dimensionUpperLimitMM(index);
  }

  dimensionLowerLimit(index : number) {
    return this.box.dimensionLowerLimitMM(index);
  }

  get box() {
    return this.$store.state.currentProject.box;
  }

  get boxDimensionNames() {
    return this.boxStyle != null ? this.boxStyle.dimensions : [];
  }

  get boxStyle() {
    return this.box.style
  }

  get globalBoxDimensionValues() {
    return this.box.dimensions;
  }

  constructor() {
    super();

    for (const v of this.box.dimensions) {
      this.localBoxDimensionValues.push(v * 1000);
      this.localBoxDimensionTextValues.push(v * 1000);
    }
  }

  onTextFieldBlur(index) {
    const value = parseInt(this.localBoxDimensionTextValues[index]);
    if (!isNaN(value))
      this.localBoxDimensionValues[index] = value;
    else
      this.localBoxDimensionTextValues[index] = this.localBoxDimensionValues[index];

    this.onLocalBoxDimensionValuesChanged();
  }

  @Watch('boxStyle')
  getDefaultDimensionValues() {
    this.localBoxDimensionValues = [];
    this.localBoxDimensionTextValues = [];
    for (const v of this.box.dimensions) {
      this.localBoxDimensionValues.push(v * 1000);
      this.localBoxDimensionTextValues.push(v * 1000);
    }
  }

  @Watch('localBoxDimensionValues')
  onLocalBoxDimensionValuesChanged() {
    let dimensions = [];
    let hasChanged = false;
    for (let i = 0; i < this.localBoxDimensionValues.length; i++) {
      let dimension = this.localBoxDimensionValues[i] / 1000;

      if (isNaN(dimension))
        dimension = 0.1;

      dimensions.push(dimension);
      hasChanged = hasChanged || this.box.dimensions[i] != dimension;

      this.localBoxDimensionTextValues[i] = this.localBoxDimensionValues[i];
    }

    if (hasChanged) {
      let box = JSON.parse(JSON.stringify(this.box));
      box.dimensions = dimensions;

      apolloClient.writeFragment({
        id: `Box:${this.box.id}`,
        fragment: BOX_DIMENSIONS_FRAGMENT_QUERY,
        data: box
      });

      this.updateDimensionsDebounced();
    }
  }

  updateDimensionValues() {
    this.$apollo.mutate({
      mutation: gql`mutation ($projectId: Int!, $boxStyleId: Int, $dimensions: [Float]!) {
          updateBox(projectId: $projectId, boxStyleId: $boxStyleId, dimensions: $dimensions) {
            ...BoxDimensions
          }
        }
        ${BOX_DIMENSIONS_FRAGMENT_QUERY}
      `,
      variables: {
        projectId: this.$store.state.currentProject.id,
        boxStyleId: null,
        dimensions: this.box.dimensions,
      },
      update: (store, {data: { updateBox }}) => {
        let box = JSON.parse(JSON.stringify(this.box));
        box.dimensions = updateBox.dimensions;

        store.writeFragment({
          id: `Box:${this.box.id}`,
          fragment: BOX_DIMENSIONS_FRAGMENT_QUERY,
          data: box
        });
      },
      optimisticResponse: {
        __typename: 'Mutation',
        updateBox: {
          __typename: 'Box',
          dimensions: this.box.dimensions,
        },
      },
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BoxDimensionSelect.vue